module.exports = __webpack_public_path__ + "static/media/28.acb58ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/28.png
// module id = 881
// module chunks = 0